export enum ProspectMethods {
  GET_PROSPECT = 'get_prospect' as any,
  PATCH_PROSPECT_GET_READY = 'patch_prospect_oca_get_ready' as any,
  POST_PROSPECT_GET_READY = 'post_prospect_oca_get_ready' as any,
  PATCH_PROSPECT_CONTACT = 'patch_prospect_oca_contact' as any,
  PATCH_PROSPECT_PLD = 'patch_prospect_oca_pld' as any,
  PATCH_PROSPECT_TRACKING = 'patch_prospect_oca_tracking' as any
}
